import { render, staticRenderFns } from "./SpacesEditorBody.vue?vue&type=template&id=42e10959&scoped=true"
import script from "./SpacesEditorBody.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorBody.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorBody.scss?vue&type=style&index=0&id=42e10959&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e10959",
  null
  
)

export default component.exports